// Generated by GitHub Copilot
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';

const s3Client = new S3Client({
  maxAttempts: 2,
  requestHandler: {
    requestTimeout: 3000,
    connectionTimeout: 3000,
  },
});

const getS3Data = async (usedBucket) => {
  try {
    const command = new GetObjectCommand(usedBucket);
    const data = await s3Client.send(command);

    // Convert the stream to string for AWS SDK v3
    const chunks = [];
    for await (const chunk of data.Body) {
      chunks.push(chunk);
    }
    const bodyString = Buffer.concat(chunks).toString('utf8');
    const s3Data = JSON.parse(bodyString);

    return {
      s3Data,
      usedBucket,
      errMsg: 'success',
    };
  } catch (errMsg) {
    console.log('kbbsdk-s3-data-service error:::::', errMsg, usedBucket);
    return {
      usedBucket,
      errMsg,
    };
  }
};

export default getS3Data;
